import { memo } from 'react'

export default memo(({ condition, children }) => (condition ? children : null))



// WEBPACK FOOTER //
// ./src/Containers/Sidebar/components/If.js